import { ObjectMapper } from "json-object-mapper";

export class SesmtEmployeeHistoryModel {
  absenses: any[] = [];
  registration: string = '';
  name: string[] = [];
  balance: number = 0;

  static create(input: any): SesmtEmployeeHistoryModel {
    return ObjectMapper.deserialize<SesmtEmployeeHistoryModel>(SesmtEmployeeHistoryModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}